module.exports = __webpack_public_path__ + "static/logo-original-0a542c6b5013f0070e243f793bea5090.svg";